import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.constructor";
import _slicedToArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import _typeof from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { FormTypes, VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil';
import { cloneObject, randomString } from '@/utils/util';
import JDate from '@/components/jeecg/JDate'; // 行高，需要在实例加载完成前用到

var rowHeight = 61;
export default {
  name: 'JEditableTable',
  components: {
    JDate: JDate
  },
  props: {
    // 列信息
    columns: {
      type: Array,
      required: true
    },
    // 数据源
    dataSource: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    // 是否显示操作按钮
    actionButton: {
      type: Boolean,
      default: false
    },
    // 是否显示行号
    rowNumber: {
      type: Boolean,
      default: false
    },
    // 是否可选择行
    rowSelection: {
      type: Boolean,
      default: false
    },
    // 页面是否在加载中
    loading: {
      type: Boolean,
      default: false
    },
    // 页面是否在加载中
    maxHeight: {
      type: Number,
      default: 400
    },
    // 要禁用的行
    disabledRows: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 是否禁用全部组件
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // caseId，用于防止有多个实例的时候会冲突
      caseId: "_jet-".concat(randomString(6), "-"),
      // 存储document element 对象
      el: {
        inputTable: null,
        tbody: null
      },
      // 存储各个div的style
      style: {
        // 'max-height': '400px'
        tbody: {
          left: '0px'
        },
        // 左侧固定td的style
        tdLeft: {
          'min-width': '4%',
          'max-width': '45px'
        }
      },
      // 表单的类型
      formTypes: FormTypes,
      // 行数据
      rows: [],
      // 行高，height + padding + border
      rowHeight: rowHeight,
      // 滚动条顶部距离
      scrollTop: 0,
      // 绑定 select 的值
      selectValues: {},
      // 绑定 checkbox 的值
      checkboxValues: {},
      // 绑定 jdate 的值
      jdateValues: {},
      // file 信息
      uploadValues: {},
      // 绑定左侧选择框已选择的id
      selectedRowIds: [],
      // 存储被删除行的id
      deleteIds: [],
      // 存储显示tooltip的信息
      tooltips: {},
      // 存储没有通过验证的inputId
      notPassedIds: []
    };
  },
  created: function created() {
    // 当前显示的tr
    this.visibleTrEls = []; // 用来存储input表单的值
    // 数组里的每项都是一个对象，对象里每个key都是input的rowKey，值就是input的值，其中有个id的字段来区分
    // 示例：
    // [{
    //    id: "_jet-4sp0iu-15541771111770"
    //    dbDefaultVal: "aaa",
    //    dbFieldName: "bbb",
    //    dbFieldTxt: "ccc",
    //    dbLength: 32
    // }]

    this.inputValues = [];
    this.disabledRowIds = this.disabledRowIds || [];
  },
  // 计算属性
  computed: {
    // expandHeight = rows.length * rowHeight
    getExpandHeight: function getExpandHeight() {
      return this.rows.length * this.rowHeight;
    },
    // 获取是否选择了部分
    getSelectIndeterminate: function getSelectIndeterminate() {
      return this.selectedRowIds.length > 0 && this.selectedRowIds.length < this.rows.length;
    },
    // 获取是否选择了全部
    getSelectAll: function getSelectAll() {
      return this.selectedRowIds.length === this.rows.length && this.rows.length > 0;
    },
    tbodyStyle: function tbodyStyle() {
      var style = Object.assign({}, this.style.tbody); // style['max-height'] = `${this.maxHeight}px`

      style['width'] = this.realTrWidth;
      return style;
    },
    showClearSelectButton: function showClearSelectButton() {
      var count = 0;

      for (var key in this.disabledRows) {
        if (this.disabledRows.hasOwnProperty(key)) count++;
      }

      return count > 0;
    },
    accessToken: function accessToken() {
      return Vue.ls.get(ACCESS_TOKEN);
    },
    realTrWidth: function realTrWidth() {
      var _this = this;

      var calcWidth = 'calc(';
      this.columns.forEach(function (column, i) {
        var type = column.type,
            width = column.width; // 隐藏字段不参与计算

        if (type !== FormTypes.hidden) {
          if (typeof width === 'number') {
            calcWidth += width + 'px';
          } else if (typeof width === 'string') {
            calcWidth += width;
          } else {
            calcWidth += '120px';
          }

          if (i < _this.columns.length - 1) {
            calcWidth += ' + ';
          }
        }
      });
      calcWidth += ')'; // console.log('calcWidth: ', calcWidth)

      return calcWidth;
    }
  },
  // 侦听器
  watch: {
    dataSource: function dataSource(newValue) {
      var _this2 = this;

      this.initialize();
      var rows = [];
      var checkboxValues = {};
      var selectValues = {};
      var jdateValues = {}; // 禁用行的id

      var disabledRowIds = this.disabledRowIds || [];
      newValue.forEach(function (data, newValueIndex) {
        // 判断源数据是否带有id
        if (data.id == null || data.id === '') {
          data.id = _this2.removeCaseId(_this2.generateId() + newValueIndex);
        }

        var value = {
          id: _this2.caseId + data.id
        };
        var row = {
          id: value.id
        };
        var disabled = false;

        _this2.columns.forEach(function (column) {
          var inputId = column.key + value.id;
          var sourceValue = (data[column.key] == null ? '' : data[column.key]).toString();

          if (column.type === FormTypes.checkbox) {
            // 判断是否设定了customValue（自定义值）
            if (column.customValue instanceof Array) {
              var customValue = (column.customValue[0] || '').toString();
              checkboxValues[inputId] = sourceValue === customValue;
            } else {
              checkboxValues[inputId] = sourceValue;
            }
          } else if (column.type === FormTypes.select) {
            if (sourceValue) {
              // 判断是否是多选
              selectValues[inputId] = (column.props || {})['mode'] === 'multiple' ? sourceValue.split(',') : sourceValue;
            } else {
              selectValues[inputId] = undefined;
            }
          } else if (column.type === FormTypes.date || column.type === FormTypes.datetime) {
            jdateValues[inputId] = sourceValue;
          } else if (column.type === FormTypes.slot) {
            if (sourceValue !== 0 && !sourceValue) {
              value[column.key] = column.defaultValue;
            } else {
              value[column.key] = sourceValue;
            }
          } else {
            value[column.key] = sourceValue;
          } // 解析disabledRows


          for (var columnKey in _this2.disabledRows) {
            // 判断是否有该属性
            if (_this2.disabledRows.hasOwnProperty(columnKey) && data.hasOwnProperty(columnKey)) {
              // row[columnKey] =
              if (disabled !== true) {
                disabled = _this2.disabledRows[columnKey] === data[columnKey];

                if (disabled) {
                  disabledRowIds.push(row.id);
                }
              }
            }
          }
        });

        _this2.inputValues.push(value);

        rows.push(row);
      });
      this.disabledRowIds = disabledRowIds;
      this.checkboxValues = checkboxValues;
      this.selectValues = selectValues;
      this.jdateValues = jdateValues;
      this.rows = rows; // 更新form表单的值

      this.$nextTick(function () {
        _this2.updateFormValues();
      });
    },
    columns: {
      immediate: true,
      handler: function handler(columns) {
        columns.forEach(function (column) {
          if (column.type === FormTypes.select) {
            // 兼容 旧版本 options
            if (column.options instanceof Array) {
              column.options = column.options.map(function (item) {
                if (item) {
                  return {
                    text: item.text || item.title,
                    title: item.text || item.title,
                    value: item.value
                  };
                }

                return {};
              });
            }
          }
        });
      }
    },
    // 当selectRowIds改变时触发事件
    selectedRowIds: function selectedRowIds(newValue) {
      this.$emit('selectRowChange', cloneObject(newValue));
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    // 获取document element对象
    var elements = {};
    ['inputTable', 'tbody'].forEach(function (id) {
      elements[id] = document.getElementById(_this3.caseId + id);
    });
    this.el = elements;
    var vm = this;
    /** 监听滚动条事件 */

    this.el.inputTable.onscroll = function (event) {
      vm.syncScrollBar(event.target.scrollLeft);
    };

    this.el.tbody.onscroll = function (event) {// vm.recalcTrHiddenItem(event.target.scrollTop)
    };

    var _this$$refs = this.$refs,
        thead = _this$$refs.thead,
        scrollView = _this$$refs.scrollView;

    scrollView.onscroll = function (event) {
      // console.log(event.target.scrollTop, ' - ', event.target.scrollLeft)
      thead.scrollLeft = event.target.scrollLeft; // vm.recalcTrHiddenItem(event.target.scrollTop)

      vm.recalcTrHiddenItem(event.target.scrollTop);
    };
  },
  methods: {
    /** 初始化列表 */
    initialize: function initialize() {
      var _this4 = this;

      this.visibleTrEls = [];
      this.rows = [];
      this.deleteIds = [];
      this.inputValues = [];
      this.selectValues = {};
      this.checkboxValues = {};
      this.jdateValues = {};
      this.selectedRowIds = [];
      this.tooltips = {};
      this.notPassedIds = [];
      this.scrollTop = 0;
      this.$nextTick(function () {
        _this4.el.tbody.scrollTop = 0;
      });
    },

    /** 同步滚动条状态 */
    syncScrollBar: function syncScrollBar(scrollLeft) {// this.style.tbody.left = `${scrollLeft}px`
      // this.el.tbody.scrollLeft = scrollLeft
    },

    /** 重置滚动条位置，参数留空则滚动到上次记录的位置 */
    resetScrollTop: function resetScrollTop(top) {
      var scrollView = this.$refs.scrollView;

      if (top != null && typeof top === 'number') {
        scrollView.scrollTop = top;
      } else {
        scrollView.scrollTop = this.scrollTop;
      }
    },

    /** 重新计算需要隐藏或显示的tr */
    recalcTrHiddenItem: function recalcTrHiddenItem(top) {
      var _this5 = this;

      var diff = top - this.scrollTop;

      if (diff < 0) {
        diff = this.scrollTop - top;
      } // 只有在滚动了百分之三十的行高的距离时才进行更新


      if (diff >= this.rowHeight * 0.3) {
        this.scrollTop = top; // 更新form表单的值

        this.$nextTick(function () {
          _this5.updateFormValues();
        });
      }
    },

    /** 生成id */
    generateId: function generateId(rows) {
      if (!(rows instanceof Array)) {
        rows = this.rows || [];
      }

      var timestamp = new Date().getTime();
      return "".concat(this.caseId).concat(timestamp).concat(rows.length);
    },

    /** push 一条数据 */
    push: function push(record) {
      var _this6 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var rows = arguments.length > 2 ? arguments[2] : undefined;

      if (!(rows instanceof Array)) {
        rows = cloneObject(this.rows) || [];
      }

      if (record.id == null) {
        record.id = this.generateId(rows); // let timestamp = new Date().getTime()
        // record.id = `${this.caseId}${timestamp}${rows.length}`
      }

      if (record.id.indexOf(this.caseId) === -1) {
        record.id = this.caseId + record.id;
      }

      var row = {
        id: record.id
      };
      var value = {
        id: row.id
      };
      var checkboxValues = Object.assign({}, this.checkboxValues);
      var selectValues = Object.assign({}, this.selectValues);
      var jdateValues = Object.assign({}, this.jdateValues);
      this.columns.forEach(function (column) {
        var key = column.key;
        var inputId = key + row.id; // record中是否有该列的值

        var recordHasValue = record[key] != null;

        if (column.type === FormTypes.input) {
          value[key] = recordHasValue ? record[key] : column.defaultValue || (column.defaultValue === 0 ? 0 : '');
        } else if (column.type === FormTypes.inputNumber) {
          // 判断是否是排序字段，如果是就赋最大值
          if (column.isOrder === true) {
            value[key] = _this6.getInputNumberMaxValue(column) + 1;
          } else {
            value[key] = recordHasValue ? record[key] : column.defaultValue || (column.defaultValue === 0 ? 0 : '');
          }
        } else if (column.type === FormTypes.checkbox) {
          checkboxValues[inputId] = recordHasValue ? record[key] : column.defaultChecked;
        } else if (column.type === FormTypes.select) {
          var selected = column.defaultValue;

          if (selected !== 0 && !selected) {
            selected = undefined;
          } // 判断多选


          if (typeof selected === 'string' && (column.props || {})['mode'] === 'multiple') {
            selected = selected.split(',');
          }

          selectValues[inputId] = recordHasValue ? record[key] : selected;
        } else if (column.type === FormTypes.date || column.type === FormTypes.datetime) {
          jdateValues[inputId] = recordHasValue ? record[key] : column.defaultValue;
        } else if (column.type === FormTypes.slot) {
          value[key] = recordHasValue ? record[key] : column.defaultValue || '';
        } else {
          value[key] = recordHasValue ? record[key] : '';
        }
      });
      rows.push(row);
      this.inputValues.push(value);
      this.checkboxValues = checkboxValues;
      this.selectValues = selectValues;
      this.jdateValues = jdateValues;

      if (update) {
        this.rows = rows;
        this.$nextTick(function () {
          _this6.updateFormValues();
        });
      }

      return rows;
    },

    /** 获取某一数字输入框列中的最大的值 */
    getInputNumberMaxValue: function getInputNumberMaxValue(column) {
      var maxNum = 0;
      this.inputValues.forEach(function (item, index) {
        var val = item[column.key],
            num;

        try {
          num = parseInt(val);
        } catch (_unused) {
          num = 0;
        } // 把首次循环的结果当成最大值


        if (index === 0) {
          maxNum = num;
        } else {
          maxNum = num > maxNum ? num : maxNum;
        }
      });
      return maxNum;
    },

    /** 添加一行 */
    add: function add() {
      var _this7 = this;

      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var forceScrollToBottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // let timestamp = new Date().getTime()
      var rows = this.rows;
      var row;

      for (var i = 0; i < num; i++) {
        // row = { id: `${this.caseId}${timestamp}${rows.length}` }
        row = {
          id: this.generateId(rows)
        };
        rows = this.push(row, false, rows);
      }

      this.rows = rows;
      this.$nextTick(function () {
        _this7.updateFormValues();
      }); // 触发add事件

      this.$emit('added', {
        row: function () {
          var r = Object.assign({}, row);
          r.id = _this7.removeCaseId(r.id);
          return r;
        }(),
        target: this
      }); // 设置滚动条位置

      var tbody = this.el.tbody;
      var offsetHeight = tbody.offsetHeight;
      var realScrollTop = tbody.scrollTop + offsetHeight;

      if (forceScrollToBottom === false) {
        // 只有滚动条在底部的时候才自动滚动
        if (!(tbody.scrollHeight - realScrollTop <= 10)) {
          return;
        }
      }

      this.$nextTick(function () {
        tbody.scrollTop = tbody.scrollHeight;
      });
    },

    /** 删除被选中的行 */
    removeSelectedRows: function removeSelectedRows() {
      this.removeRows(this.selectedRowIds);
      this.selectedRowIds = [];
    },

    /** 删除一行或多行 */
    removeRows: function removeRows(id) {
      var _this8 = this;

      var ids = id;

      if (!(id instanceof Array)) {
        if (typeof id === 'string') {
          ids = [id];
        } else {
          throw "JEditableTable.removeRows() \u51FD\u6570\u9700\u8981\u7684\u53C2\u6570\u53EF\u4EE5\u662Fstring\u6216Array\u7C7B\u578B\uFF0C\u4F46\u63D0\u4F9B\u7684\u5374\u662F".concat(_typeof(id));
        }
      }

      var rows = cloneObject(this.rows);
      ids.forEach(function (removeId) {
        // 找到每个id对应的真实index并删除
        var findAndDelete = function findAndDelete(arr) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === removeId || arr[i].id === _this8.caseId + removeId) {
              arr.splice(i, 1);
              return true;
            }
          }
        }; // 找到rows对应的index，并删除


        if (findAndDelete(rows)) {
          // 找到values对应的index，并删除
          findAndDelete(_this8.inputValues); // 将caseId去除

          var _id = _this8.removeCaseId(removeId);

          _this8.deleteIds.push(_id);
        }
      });
      this.rows = rows;
      this.$emit('deleted', this.getDeleteIds());
      this.$nextTick(function () {
        // 更新formValues
        _this8.updateFormValues();
      });
      return true;
    },

    /** 获取表格表单里的值（同步版） */
    getValuesSync: function getValuesSync() {
      var _this9 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var validate = options.validate,
          rowIds = options.rowIds;
      if (typeof validate !== 'boolean') validate = true;
      if (!(rowIds instanceof Array)) rowIds = null; // console.log('options:', { validate, rowIds })

      var error = 0;
      var inputValues = cloneObject(this.inputValues);
      var tooltips = Object.assign({}, this.tooltips);
      var notPassedIds = cloneObject(this.notPassedIds); // 用于存储合并后的值

      var values = []; // 遍历inputValues来获取每行的值

      var _iterator = _createForOfIteratorHelper(inputValues),
          _step;

      try {
        var _loop = function _loop() {
          var value = _step.value;
          var rowIdsFlag = false; // 如果带有rowIds，那么就只存这几行的数据

          if (rowIds == null) {
            rowIdsFlag = true;
          } else {
            var _iterator2 = _createForOfIteratorHelper(rowIds),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var rowId = _step2.value;

                if (rowId === value.id || "".concat(_this9.caseId).concat(rowId) === value.id) {
                  rowIdsFlag = true;
                  break;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }

          if (!rowIdsFlag) return "continue";

          _this9.columns.forEach(function (column) {
            var inputId = column.key + value.id;

            if (column.type === FormTypes.checkbox) {
              var checked = _this9.checkboxValues[inputId];

              if (column.customValue instanceof Array) {
                value[column.key] = checked ? column.customValue[0] : column.customValue[1];
              } else {
                value[column.key] = checked;
              }
            } else if (column.type === FormTypes.select) {
              var selected = _this9.selectValues[inputId];

              if (selected instanceof Array) {
                value[column.key] = cloneObject(selected);
              } else {
                value[column.key] = selected;
              }
            } else if (column.type === FormTypes.date || column.type === FormTypes.datetime) {
              value[column.key] = _this9.jdateValues[inputId];
            } else if (column.type === FormTypes.upload) {
              value[column.key] = cloneObject(_this9.uploadValues[inputId] || null);
            } // 检查表单验证


            if (validate === true) {
              var results = _this9.validateOneInput(value[column.key], value, column, notPassedIds, false);

              tooltips[inputId] = results[0];

              if (tooltips[inputId].visible) {
                error++; // if (error++ === 0) {
                // let element = document.getElementById(inputId)
                // while (element.className !== 'tr') {
                //   element = element.parentElement
                // }
                // this.jumpToId(inputId, element)
                // }
              }

              tooltips[inputId].visible = false;
              notPassedIds = results[1];
            }
          }); // 将caseId去除


          value.id = _this9.removeCaseId(value.id);
          values.push(value);
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.tooltips = tooltips;
      this.notPassedIds = notPassedIds;
      return {
        error: error,
        values: values
      };
    },

    /** 获取表格表单里的值 */
    getValues: function getValues(callback) {
      var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var rowIds = arguments.length > 2 ? arguments[2] : undefined;
      var result = this.getValuesSync({
        validate: validate,
        rowIds: rowIds
      });

      if (typeof callback === 'function') {
        callback(result.error, result.values);
      }
    },

    /** getValues的Promise版 */
    getValuesPromise: function getValuesPromise() {
      var _this10 = this;

      var validate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var rowIds = arguments.length > 1 ? arguments[1] : undefined;
      return new Promise(function (resolve, reject) {
        var _this10$getValuesSync = _this10.getValuesSync({
          validate: validate,
          rowIds: rowIds
        }),
            error = _this10$getValuesSync.error,
            values = _this10$getValuesSync.values;

        if (error === 0) {
          resolve(values);
        } else {
          reject(VALIDATE_NO_PASSED);
        }
      });
    },

    /** 获取被删除项的id */
    getDeleteIds: function getDeleteIds() {
      return cloneObject(this.deleteIds);
    },

    /** 获取所有的数据，包括values、deleteIds */
    getAll: function getAll(validate) {
      var _this11 = this;

      return new Promise(function (resolve, reject) {
        var deleteIds = _this11.getDeleteIds();

        _this11.getValuesPromise(validate).then(function (values) {
          resolve({
            values: values,
            deleteIds: deleteIds
          });
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    /** Sync 获取所有的数据，包括values、deleteIds */
    getAllSync: function getAllSync(validate, rowIds) {
      var result = this.getValuesSync({
        validate: validate,
        rowIds: rowIds
      });
      result.deleteIds = this.getDeleteIds();
      return result;
    },
    // slot 获取值
    _getValueForSlot: function _getValueForSlot(rowId) {
      return this.getValuesSync({
        rowIds: [rowId]
      }).values[0];
    },

    /** 设置某行某列的值 */
    setValues: function setValues(values) {
      var _this12 = this;

      values.forEach(function (item) {
        var rowKey = item.rowKey,
            newValues = item.values;

        var _loop2 = function _loop2(newValueKey) {
          if (newValues.hasOwnProperty(newValueKey)) {
            var newValue = newValues[newValueKey];
            var edited = false; // 已被修改

            _this12.inputValues.forEach(function (value) {
              // 在inputValues中找到了该字段
              if ("".concat(_this12.caseId).concat(rowKey) === value.id) {
                if (value.hasOwnProperty(newValueKey)) {
                  edited = true;
                  value[newValueKey] = newValue;
                }
              }
            });

            var modelKey = "".concat(newValueKey).concat(_this12.caseId).concat(rowKey); // 在 selectValues 中寻找值

            if (!edited && _this12.selectValues.hasOwnProperty(modelKey)) {
              if (newValue !== 0 && !newValue) {
                _this12.selectValues[modelKey] = undefined;
              } else {
                _this12.selectValues[modelKey] = newValue;
              }

              edited = true;
            } // 在 checkboxValues 中寻找值


            if (!edited && _this12.checkboxValues.hasOwnProperty(modelKey)) {
              _this12.checkboxValues[modelKey] = newValue;
              edited = true;
            } // 在 jdateValues 中寻找值


            if (!edited && _this12.jdateValues.hasOwnProperty(modelKey)) {
              _this12.jdateValues[modelKey] = newValue;
              edited = true;
            }
          }
        };

        for (var newValueKey in newValues) {
          _loop2(newValueKey);
        }
      }); // 强制更新formValues

      this.forceUpdateFormValues();
    },

    /** 跳转到指定位置 */
    // jumpToId(id, element) {
    //   if (element == null) {
    //     element = document.getElementById(id)
    //   }
    //   if (element != null) {
    //     console.log(this.el.tbody.scrollTop, element.offsetTop)
    //     this.el.tbody.scrollTop = element.offsetTop
    //     console.log(this.el.tbody.scrollTop, element.offsetTop)
    //   }
    // },

    /** 验证单个表单 */
    validateOneInput: function validateOneInput(value, row, column, notPassedIds) {
      var update = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var tooltips = Object.assign({}, this.tooltips); // let notPassedIds = cloneObject(this.notPassedIds)

      var inputId = column.key + row.id;

      var _this$validateValue = this.validateValue(column.validateRules, value),
          _this$validateValue2 = _slicedToArray(_this$validateValue, 2),
          passed = _this$validateValue2[0],
          message = _this$validateValue2[1];

      tooltips[inputId] = tooltips[inputId] ? tooltips[inputId] : {};
      tooltips[inputId].visible = !passed;
      var index = notPassedIds.indexOf(inputId);
      var borderColor = null,
          boxShadow = null;

      if (!passed) {
        tooltips[inputId].title = this.replaceProps(column, message);
        borderColor = 'red';
        boxShadow = "0 0 0 2px rgba(255, 0, 0, 0.2)";
        if (index === -1) notPassedIds.push(inputId);
      } else {
        if (index !== -1) notPassedIds.splice(index, 1);
      }

      var element = document.getElementById(inputId);

      if (element != null) {
        // select 在 .ant-select-selection 上设置 border-color
        if (column.type === FormTypes.select) {
          element = element.getElementsByClassName('ant-select-selection')[0];
        } // jdate 在 input 上设置 border-color


        if (column.type === FormTypes.date || column.type === FormTypes.datetime) {
          element = element.getElementsByTagName('input')[0];
        }

        element.style.borderColor = borderColor;
        element.style.boxShadow = boxShadow;
      } // 是否更新到data


      if (update) {
        this.tooltips = tooltips;
        this.notPassedIds = notPassedIds;
      }

      return [tooltips[inputId], notPassedIds];
    },

    /** 通过规则验证值是否正确 */
    validateValue: function validateValue(rules, value) {
      var passed = true,
          message = ''; // 判断有没有验证规则或验证规则格式正不正确，若条件不符合则默认通过

      if (rules instanceof Array) {
        var _iterator3 = _createForOfIteratorHelper(rules),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var rule = _step3.value;
            // 当前值是否为空
            var isNull = value == null || value === ''; // 验证规则：非空

            if (rule.required === true && isNull) {
              passed = false;
            } else // 使用 else-if 是为了防止一个 rule 中出现两个规则
              // 验证规则：正则表达式
              if (!!rule.pattern && !isNull) {
                passed = new RegExp(rule.pattern).test(value);
              } // 如果没有通过验证，则跳出循环。如果通过了验证，则继续验证下一条规则


            if (!passed) {
              message = rule.message;
              break;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      return [passed, message];
    },

    /** 动态更新表单的值 */
    updateFormValues: function updateFormValues() {
      var _this13 = this;

      var trs = this.el.tbody.getElementsByClassName('tr');
      var trEls = [];

      var _iterator4 = _createForOfIteratorHelper(trs),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _tr = _step4.value;
          trEls.push(_tr);
        } // 获取新增的 tr

      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var newTrEls = trEls;

      if (this.visibleTrEls.length > 0) {
        newTrEls = [];

        var _iterator5 = _createForOfIteratorHelper(trEls),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var tr = _step5.value;
            var isNewest = true;

            var _iterator6 = _createForOfIteratorHelper(this.visibleTrEls),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var vtr = _step6.value;

                if (vtr.id === tr.id) {
                  isNewest = false;
                  break;
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }

            if (isNewest) {
              newTrEls.push(tr);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      this.visibleTrEls = trEls; // 向新增的tr中赋值

      newTrEls.forEach(function (tr) {
        var idx = tr.dataset.idx;
        var value = _this13.inputValues[idx];

        for (var key in value) {
          if (value.hasOwnProperty(key)) {
            var elid = "".concat(key).concat(value.id);
            var el = document.getElementById(elid);

            if (el) {
              el.value = value[key];
            }
          }
        }
      });
    },

    /** 强制更新FormValues */
    forceUpdateFormValues: function forceUpdateFormValues() {
      this.visibleTrEls = [];
      this.updateFormValues();
    },

    /** 全选或取消全选 */
    handleChangeCheckedAll: function handleChangeCheckedAll() {
      var _this14 = this;

      var selectedRowIds = [];

      if (!this.getSelectAll) {
        this.rows.forEach(function (row) {
          if ((_this14.disabledRowIds || []).indexOf(row.id) === -1) {
            selectedRowIds.push(row.id);
          }
        });
      }

      this.selectedRowIds = selectedRowIds;
    },

    /** 左侧行选择框change事件 */
    handleChangeLeftCheckbox: function handleChangeLeftCheckbox(event) {
      var id = event.target.id;

      if ((this.disabledRowIds || []).indexOf(id) !== -1) {
        return;
      }

      var index = this.selectedRowIds.indexOf(id);

      if (index !== -1) {
        this.selectedRowIds.splice(index, 1);
      } else {
        this.selectedRowIds.push(id);
      }
    },
    handleClickAdd: function handleClickAdd() {
      this.add();
    },
    handleConfirmDelete: function handleConfirmDelete() {
      this.removeSelectedRows();
    },
    handleClickClearSelect: function handleClickClearSelect() {
      this.selectedRowIds = [];
    },

    /** select 搜索时的事件，用于动态添加options */
    handleSearchSelect: function handleSearchSelect(value, id, row, col) {
      if (col.allowInput === true) {
        // 是否找到了对应的项，找不到则添加这一项
        var flag = false;

        var _iterator7 = _createForOfIteratorHelper(col.options),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var option = _step7.value;

            if (option.value.toLocaleString() === value.toLocaleString()) {
              flag = true;
              break;
            }
          } // !!value ：不添加空值

        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        if (!flag && !!value) {
          // searchAdd 是否是通过搜索添加的
          col.options.push({
            title: value,
            value: value,
            searchAdd: true
          });
        }
      }
    },
    // blur 失去焦点
    handleBlurSearch: function handleBlurSearch(value, id, row, col) {
      if (col.allowInput === true) {
        // 删除无用的因搜索（用户输入）而创建的项
        if (typeof value === 'string') {
          var indexs = [];
          col.options.forEach(function (option, index) {
            if (option.value.toLocaleString() === value.toLocaleString()) {
              delete option.searchAdd;
            } else if (option.searchAdd === true) {
              indexs.push(index);
            }
          }); // 翻转删除数组中的项

          var _iterator8 = _createForOfIteratorHelper(indexs.reverse()),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var index = _step8.value;
              col.options.splice(index, 1);
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }
      }
    },

    /* --- common function begin --- */

    /** 鼠标移入 */
    handleMouseoverCommono: function handleMouseoverCommono(row, column) {
      var inputId = column.key + row.id;

      if (this.notPassedIds.indexOf(inputId) !== -1) {
        this.showOrHideTooltip(inputId, true);
      }
    },

    /** 鼠标移出 */
    handleMouseoutCommono: function handleMouseoutCommono(row, column) {
      var inputId = column.key + row.id;
      this.showOrHideTooltip(inputId, false);
    },

    /** input事件 */
    handleInputCommono: function handleInputCommono(target, index, row, column) {
      var value = target.value,
          dataset = target.dataset,
          selectionStart = target.selectionStart;
      var type = FormTypes.input;
      var change = true;

      if ("".concat(dataset.inputNumber) === 'true') {
        type = FormTypes.inputNumber;
        var replace = value.replace(/[^0-9]/g, '');

        if (value !== replace) {
          change = false;
          value = replace;
          target.value = replace;

          if (typeof selectionStart === 'number') {
            target.selectionStart = selectionStart - 1;
            target.selectionEnd = selectionStart - 1;
          }
        }
      } // 存储输入的值


      this.inputValues[index][column.key] = value; // 做单个表单验证

      this.validateOneInput(value, row, column, this.notPassedIds, true); // 触发valueChange 事件

      if (change) {
        this.elemValueChange(type, row, column, value);
      }
    },
    handleChangeCheckboxCommon: function handleChangeCheckboxCommon(event, row, column) {
      var _event$target = event.target,
          id = _event$target.id,
          checked = _event$target.checked;
      this.checkboxValues = this.bindValuesChange(checked, id, 'checkboxValues'); // 触发valueChange 事件

      this.elemValueChange(FormTypes.checkbox, row, column, checked);
    },
    handleChangeSelectCommon: function handleChangeSelectCommon(value, id, row, column) {
      this.selectValues = this.bindValuesChange(value, id, 'selectValues'); // 做单个表单验证

      this.validateOneInput(value, row, column, this.notPassedIds, true); // 触发valueChange 事件

      this.elemValueChange(FormTypes.select, row, column, value);
    },
    handleChangeJDateCommon: function handleChangeJDateCommon(value, id, row, column, showTime) {
      this.jdateValues = this.bindValuesChange(value, id, 'jdateValues');
      this.validateOneInput(value, row, column, this.notPassedIds, true); // 触发valueChange 事件

      if (showTime) {
        this.elemValueChange(FormTypes.datetime, row, column, value);
      } else {
        this.elemValueChange(FormTypes.date, row, column, value);
      }
    },
    handleChangeUpload: function handleChangeUpload(info, id, row, column) {
      var file = info.file;
      var value = {
        name: file.name,
        type: file.type,
        size: file.size,
        status: file.status,
        percent: file.percent
      };

      if (column.responseName && file.response) {
        value['responseName'] = file.response[column.responseName];
      }

      this.uploadValues = this.bindValuesChange(value, id, 'uploadValues');
    },

    /** 记录用到数据绑定的组件的值 */
    bindValuesChange: function bindValuesChange(value, id, key) {
      var values = Object.assign({}, this[key]);
      values[id] = value;
      return values;
    },

    /** 显示或隐藏tooltip */
    showOrHideTooltip: function showOrHideTooltip(inputId, show) {
      var tooltips = Object.assign({}, this.tooltips);
      tooltips[inputId] = tooltips[inputId] ? tooltips[inputId] : {};
      tooltips[inputId].visible = show;
      this.tooltips = tooltips;
    },

    /** value 触发valueChange事件 */
    elemValueChange: function elemValueChange(type, rowSource, columnSource, value) {
      var column = Object.assign({}, columnSource); // 将caseId去除

      var row = Object.assign({}, rowSource);
      row.id = this.removeCaseId(row.id); // 获取整行的数据

      var _this$getValuesSync = this.getValuesSync({
        validate: false,
        rowIds: [row.id]
      }),
          values = _this$getValuesSync.values;

      if (values.length > 0) {
        Object.assign(row, values[0]);
      }

      this.$emit('valueChange', {
        type: type,
        row: row,
        column: column,
        value: value,
        target: this
      });
    },

    /** 将caseId去除 */
    removeCaseId: function removeCaseId(id) {
      var remove = id.split(this.caseId)[1];
      return remove ? remove : id;
    },
    handleClickDelFile: function handleClickDelFile(id) {
      this.uploadValues[id] = null;
    },

    /* --- common function end --- */

    /* --- 以下是辅助方法，多用于动态构造页面中的数据 --- */

    /** 辅助方法：打印日志 */
    log: console.log,
    getVM: function getVM() {
      return this;
    },

    /** 辅助方法：指定a-select 和 j-data 的父容器 */
    getParentContainer: function getParentContainer(node) {
      if (this.$el && this.$el.nodeType !== 8) {
        return this.$el;
      }

      var doc = document.getElementById(this.caseId + 'inputTable');

      if (doc != null) {
        return doc;
      }

      return node.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
    },

    /** 辅助方法：替换${...}变量 */
    replaceProps: function replaceProps(col, value) {
      if (value && typeof value === 'string') {
        value = value.replace(/\${title}/g, col.title);
        value = value.replace(/\${key}/g, col.key);
        value = value.replace(/\${defaultValue}/g, col.defaultValue);
      }

      return value;
    },

    /** view辅助方法：构建 tr style */
    buildTrStyle: function buildTrStyle(index) {
      return {
        'top': "".concat(rowHeight * index, "px")
      };
    },

    /** view辅助方法：构建 td style */
    buildTdStyle: function buildTdStyle(col) {
      var style = {}; // 计算宽度

      if (col.width) {
        style['width'] = col.width;
      } else if (this.columns) {
        style['width'] = "".concat((100 - 4 * 2) / this.columns.length, "%");
      } else {
        style['width'] = '120px';
      } // checkbox 居中显示


      var isCheckbox = col.type === FormTypes.checkbox;

      if (isCheckbox) {
        style['align-items'] = 'center';
        style['text-align'] = 'center';
        style['padding-left'] = '0';
        style['padding-right'] = '0';
      }

      return style;
    },

    /** view辅助方法：构造props */
    buildProps: function buildProps(row, col) {
      var props = {}; // 解析props

      if (_typeof(col.props) === 'object') {
        for (var prop in col.props) {
          if (col.props.hasOwnProperty(prop)) {
            props[prop] = this.replaceProps(col, col.props[prop]);
          }
        }
      } // 判断select是否允许输入


      if (col.type === FormTypes.select && col.allowInput === true) {
        props['showSearch'] = true;
      } // 判断是否为禁用的行


      if (props['disabled'] !== true) {
        props['disabled'] = (this.disabledRowIds || []).indexOf(row.id) !== -1;
      } // 判断是否禁用全部组件


      if (this.disabled === true) {
        props['disabled'] = true;
      }

      return props;
    },

    /** upload 辅助方法：获取 headers */
    uploadGetHeaders: function uploadGetHeaders(row, column) {
      var headers = {};

      if (column.token === true) {
        headers['X-Access-Token'] = this.accessToken;
      }

      return headers;
    }
  }
};